import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export const getBackgroundImageOptions = ({
  defaultValue = {
    placeholder: "",
    signed_id: "",
  },
}: {
  defaultValue?: {
    placeholder?: string;
    signed_id: string;
  };
} = {}): StyleValue => ({
  type: "background-image",
  value: defaultValue,
});
